<template>
  <a class="author with-avatar" href="#">
    <img alt :src="current.image" />
    <span>{{ current.name }}</span>
  </a>
</template>

<script>
export default {
  props: {
    current: {
      type: Object
    }
  },
  mounted() {},
  methods: {}
};
</script>
